<div class="country-info-container" [class]="themeService.getTheme()" [style]="border ? '' : 'border: none;'">
  <div class="country-info-workspace">
    <div class="country-info-workspace-left col-3">
      <div class="image-container">
        <div class="fix-img">
          <img
            [src]="background"
            [style]="location.cssStyleImage"
            [style.object-position]="objectPosition"
            [style.scale]="scale"
            (click)="emitObj(location.titleEn)"
            alt="Country image"
            class="country-image"
            [style.cursor]="type === 'service' ? 'default' : 'pointer'"
          >
        </div>
        <div class="country-info-label" (click)="emitObj(location.titleEn)">
          <div class="country-info-label-en" [style.cursor]="type === 'service' ? 'default' : 'pointer'">
            <app-texts
              [texts]="[
            {text: [location.titleRu, location.titleEn]}
          ]"
            />
          </div>
          <div class="country-info-label-other">
          <span *ngIf="location.titleNatural !== ''" style="cursor:pointer;">
            <app-texts [texts]="[
              {text: [location.titleNatural, location.titleNatural]}
            ]"/>
          </span>
            <span *ngIf="location.titleNatural === ''" style="cursor:pointer;">
            <app-texts
              [texts]="[
            {text: [location.titleRu, location.titleEn]}
          ]"
            />
          </span>
          </div>
        </div>
      </div>

    </div>
    <div class="country-info-workspace-middle col-6" *ngIf="type === 'classic' && !isMobile">
      <div class="country-info-middle-title-container">
        <app-texts
          [texts]="[
            {text: [location.titleRu, location.titleEn]}
          ]"
        />
      </div>
      <div class="country-info-middle-el-container-father">
        <div class="country-info-middle-el-container">
          <div class="county-subtitle">
            <app-texts
              [texts]="tour"
            />
          </div>
          <div class="county-quantity">{{ location.routeCount + ' ' + text(getCorrectEnding(location.routeCount ?? 0, 'tour')) }}</div>
          <div class="county-quantity-mob">{{ location.routeCount }}</div>
        </div>
        <div class="country-info-middle-el-container flanks-middle">
          <div class="county-subtitle">
            <app-texts
              [texts]="city"
            />
          </div>
          <div class="county-quantity">{{ location.cityCount + ' ' + text(getCorrectEnding(location.cityCount ?? 0, 'city')) }}</div>
          <div class="county-quantity-mob">{{ location.cityCount }}</div>
        </div>
        <div class="country-info-middle-el-container">
          <div class="county-subtitle">
            <app-texts
              [texts]="hotel"
            />
          </div>
          <div class="county-quantity">{{ location.hotelCount + ' ' + text(getCorrectEnding(location.hotelCount ?? 0, 'hotel')) }}</div>
          <div class="county-quantity-mob">{{ location.hotelCount }}</div>
        </div>
      </div>
    </div>
    <div class="country-info-workspace-right col-1" *ngIf="type === 'classic' && !isMobile">
      <div class="country-info-icon-container"
           (mouseenter)="startAnimation($event)">
        <app-icon
          [icon]="Icons.squareArrow"
          [invert]="getInvert()"
          (click)="emitObj(location.titleEn)"
          class="country-info-icon"
        />
      </div>
    </div>
    <div class="country-info-workspace-services col-6" *ngIf="type === 'service' && !isMobile">
      <div class="service-text-wrapper">
        <div class="service-text-content" [class.collapsed]="!openFull" [class.expanded]="openFull">
          <div *ngIf="!openFull">
            {{ subtitleTextShort }}
            <span class="services-show-button" (click)="openFull = !openFull">
              <span class="border-bottom-line">{{text(['Детали', 'Details'])}}</span>
              <img src="app/assets/icons/elArrow.svg" alt="arrow" [class.rotated]="openFull">
            </span>
          </div>

          <div *ngIf="openFull">
            <span style="white-space: pre-line;">{{ subtitleTextFull }}</span>
            <span class="services-show-button" (click)="openFull = !openFull">
              <span class="border-bottom-line">{{text(['Закрыть', 'Close'])}}</span>
    <img src="app/assets/icons/elArrow.svg" [class.rotated]="openFull" alt="arrow">
  </span>
            <div class="request-button-container">
              <div class="request-button" (click)="openFeedback()">
                {{text(['Отправить запрос', 'Make request'])}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="country-info-workspace-mobile col-9" *ngIf="isMobile" [style]="type === 'classic' ? 'height: 120px' : ''">
      <div class="country-info-workspace-mobile-label">
        <div class="label-content">
    <span (click)="emitObj(location.titleEn)" class="label-text">
      {{text([location.titleRu, location.titleEn])}}
    </span>
          <app-icon
            class="country-info-workspace-mobile-label-icon"
            *ngIf="type === 'service'"
            [icon]="Icons.mobileArrowRight"
            (click)="openService()"
          />
        </div>
      </div>
      <div class="country-info-workspace-mobile-content-services" *ngIf="type === 'service'">
        {{ subtitleTextShort }}
      </div>
      <div class="country-info-workspace-mobile-content" *ngIf="type === 'classic'">
        <div class="count-el" style="padding-right: 24px">
          <div class="count-el-top">
            <app-texts
              [texts]="tour"
            />
          </div>
          <div class="count-el-bot">
            {{ location.routeCount }}
          </div>
        </div>
        <div class="count-el flanks-mob-middle" style="padding: 0 24px">
          <div class="count-el-top">
            <app-texts
              [texts]="city"
            />
          </div>
          <div class="count-el-bot">
            {{ location.cityCount }}
          </div>
        </div>
        <div class="count-el" style="padding-left: 24px">
          <div class="count-el-top">
            <app-texts
              [texts]="hotel"
            />
          </div>
          <div class="count-el-bot">
            {{ location.hotelCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
